var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { ArrayMinSize, IsArray, IsDate, IsOptional, IsUUID, ValidateNested } from 'class-validator';
import { PatientAvailabilityDto } from './patient-availability.dto.js';
import { TreatmentConstraintDto } from './treatment-constraint.dto.js';
export class FindAvailableSlotsRequestDto {
    officeLocationId;
    from;
    to;
    treatmentConstraints;
    patientAvailability;
    therapistId;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], FindAvailableSlotsRequestDto.prototype, "officeLocationId", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], FindAvailableSlotsRequestDto.prototype, "from", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], FindAvailableSlotsRequestDto.prototype, "to", void 0);
__decorate([
    IsArray(),
    ArrayMinSize(1),
    ValidateNested({ each: true }),
    Type(() => TreatmentConstraintDto),
    __metadata("design:type", Array)
], FindAvailableSlotsRequestDto.prototype, "treatmentConstraints", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => PatientAvailabilityDto),
    __metadata("design:type", PatientAvailabilityDto)
], FindAvailableSlotsRequestDto.prototype, "patientAvailability", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], FindAvailableSlotsRequestDto.prototype, "therapistId", void 0);
//# sourceMappingURL=find-available-slots-request.dto.js.map